module.exports = __webpack_public_path__ + "static/media/black_hand.543d5973.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bonuses/black_hand.png
// module id = 1752
// module chunks = 0